import Icon from '../Icon/Icon.js'
import { ButtonIcon, ButtonLabel, ButtonWrapper } from './Button.styles.js'

const Button = ({ children, variant = 'primary', size = 'default', onClick, icon, addRightMargin, disabled }) => {
  return (
    <ButtonWrapper variant={variant} size={size} onClick={onClick} addRightMargin={addRightMargin} disabled={disabled}>
      {icon && (
        <ButtonIcon variant={variant}>
          <Icon name={icon} size={18} />
        </ButtonIcon>
      )}
      <ButtonLabel size={size} variant={variant}>
        {children}
      </ButtonLabel>
    </ButtonWrapper>
  )
}

export default Button
